/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-05-30 16:12:53
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\UserLayout\locales\zh-CN.ts
 */
export default {
  'user-layout.menu.login': '登录',
  'user-layout.menu.register': '注册',
  'user-layout.menu.activation': '激活',
  'user-layout.menu.activationemail': '邮箱激活',
  'user-layout.menu.success': '成功',
};
